NtechApp.FormSingleFileUploader = function($uploaderTrigger, $uploaderHidden, $uploaderInfo, $imagePreview) {
    var me = this;

    this._$uploaderTrigger = null;
    this._$uploaderHidden = null;
    this._$uploaderInfo = null;
    this._$imagePreview = null;

    this._click = null;

    this._loader = null;
    this._overlay = null;

    this._construct = function() {
        me._$uploaderTrigger = $uploaderTrigger;
        me._$uploaderHidden = $uploaderHidden;
        me._$uploaderInfo = $uploaderInfo;
        me._$imagePreview = $imagePreview;

        me._click = new NtechApp.TouchClickEvent();
        me._loader = new NtechApp.Loader();
        me._overlay = new NtechApp.Overlay();

        me._createUploader();

        me._bindEvents();
    }

    this._bindEvents = function() {
        var lockClick = false;
        var unlockClickTimeout = null;

        me._click.listen(me._$uploaderTrigger, function(event) {
            if(lockClick) return;
            lockClick = true;

            me._$uploaderTrigger.find(":file").trigger("click");
        });
        me._click.listen(me._$uploaderTrigger.find(":file"), function(e) {
            clearTimeout(unlockClickTimeout);
            unlockClickTimeout = setTimeout(function() {
                lockClick = false;
            }, 20);
        });

        me._$uploaderTrigger.on("dragover", function() {
            me._$uploaderTrigger.addClass("selected");
        });
        me._$uploaderTrigger.on("dragleave", function() {
            me._$uploaderTrigger.removeClass("selected");
        });
        $("body").on("dragend drop", function() {
            me._$uploaderTrigger.removeClass("selected");
        });

        NtechApp.uploader.cancelBodyDrops();
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;

    return this;
};

NtechApp.proto(NtechApp.FormSingleFileUploader, {
    _enableLoader: function() {
        this._overlay.on();
        this._loader.on();
    },

    _disableLoader: function() {
        this._overlay.off();
        this._loader.off();
    },

    _createUploader: function() {
        var me = this;

        this._$uploaderTrigger.find(":file").fileupload({
            dropZone: this._$uploaderTrigger,
            dataType: 'json',
            formData: {
                uploadType: this._$uploaderTrigger.attr("data-uploadType")
            },
            add: function(e, data) {
                $.each(data.files, function(index, file) {
                    if(!NtechApp.uploader.hasFileValidSize(file))
                        return;

                    me._enableLoader();
                    data.submit();
                });
            },
            done: function (e, data) {
                $.each(data.result, function(i, fileData) {
                    if(fileData.error) {
                        NtechApp.info.on(fileData.errorMsg, 3000);
                        me._disableLoader();
                    }
                    else
                        me._onUploadEnd(data, fileData);
                });
            }
        });
    },

    _isImage: function(filename) {
        var parts = filename.split(".");
        var ext = parts[parts.length - 1];

        var images = ["jpg", "jpeg", "gif", "png"];
        var isImage = false;
        for(var i = 0; i < images.length; i++) {
            if(ext == images[i]) {
                isImage = true;
                break;
            }
        }

        return isImage;
    },

    _onUploadEnd: function(data, fileData) {
        var $link = $("<a/>").text("View");
        $link.attr("href", fileData.url).attr("target", "blank");

        this._$uploaderInfo.html("");
        this._$uploaderInfo.append("File: " + fileData.originalFilename + " | ");
        this._$uploaderInfo.append($link);

        this._$uploaderHidden.val(fileData.filename);

        if(this._isImage(fileData.filename)) {
            this._$imagePreview.removeClass("hidden");
            this._$imagePreview.find("a").attr("href", fileData.url);
            this._$imagePreview.find("img").attr("src", fileData.url);
        }
        else {
            this._$imagePreview.addClass("hidden");
        }

        NtechApp.info.on("File uploaded succesfully.");
        this._disableLoader();
    }
});